import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App';
import ThemeProvider from "./components/HOC/ThemeProvider";
import {Provider} from "react-redux";
import store from "./store/store";
import {BrowserRouter} from "react-router-dom";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <ThemeProvider>
            <BrowserRouter basename="/sport_nutrition">
                <App/>
            </BrowserRouter>
        </ThemeProvider>
    </Provider>
);
